// Recommended
import { ReactComponent as GmailIcon } from "../../Assets/img/icons/Gmail.svg"
import { ReactComponent as LinkedinIcon } from "../../Assets/img/icons/linkedin.svg"
// import { ReactComponent as WhatsappIcon } from "../../Assets/img/icons/Whatsapp-32px.svg"
import { ReactComponent as FacebookIcon } from "../../Assets/img/icons/icons8-facebook.svg"
import { ReactComponent as InstagramIcon } from "../../Assets/img/icons/instagram.svg"

// Contacts
import { ReactComponent as SignalIcon } from "../../Assets/img/icons/signal.svg"
// import { ReactComponent as ContactCardIcon } from "../../Assets/img/icons/contact-card-icon.svg"
import { ReactComponent as FacetimeIcon } from "../../Assets/img/icons/facetime-icon.svg"
import { ReactComponent as GMapIcon } from "../../Assets/img/icons/gmap-icon.svg"
import { ReactComponent as OutlookIcon } from "../../Assets/img/icons/outlook.svg"

//Social Media
import { ReactComponent as TelegramIcon } from "../../Assets/img/icons/Telegram.svg"
import { ReactComponent as ThreadsIcon } from "../../Assets/img/icons/threads-icon.svg"
import { ReactComponent as SnapchatIcon } from "../../Assets/img/icons/snapchat-icon.svg"
import { ReactComponent as TwitchIcon } from "../../Assets/img/icons/twitch.svg"
import { ReactComponent as TwitterIcon } from "../../Assets/img/icons/twitter.svg"
import { ReactComponent as YoutubeIcon } from "../../Assets/img/icons/youtube.svg"

//Business
import { ReactComponent as BookMyShowIcon } from "../../Assets/img/icons/bookmyshow.svg"
import { ReactComponent as GoogleReviewIcon } from "../../Assets/img/icons/google-review.svg"
import { ReactComponent as JustDialIcon } from "../../Assets/img/icons/justdial.svg"

//Portfolio
import { ReactComponent as DribbleIcon } from "../../Assets/img/icons/dribbble 1.svg"
import { ReactComponent as BehanceIcon } from "../../Assets/img/icons/behance.svg"
import { ReactComponent as GithubIcon } from "../../Assets/img/icons/Github-2.svg"
import { ReactComponent as AdobePortfolioIcon } from "../../Assets/img/icons/adobe-portfolio.svg"
import { ReactComponent as FigmaIcon } from "../../Assets/img/icons/figma.svg"
import { ReactComponent as PublicIcon } from "../../Assets/img/icons/Website_social.svg"
import { ReactComponent as MdInsertLink } from "../../Assets/img/icons/Portfolio_Social.svg"
// import  { MdInsertLink } from "react-icons/md";

//Content
import { ReactComponent as ShareChatIcon } from "../../Assets/img/icons/share-chat.svg"
import { ReactComponent as TumblrIcon } from "../../Assets/img/icons/tumblr.svg"

//Payments
import { ReactComponent as PhonePeIcon } from "../../Assets/img/icons/PhonePe.svg"
import { ReactComponent as GooglePayIcon } from "../../Assets/img/icons/google-pay.svg"
import { ReactComponent as PayPalIcon } from "../../Assets/img/icons/paypal.svg"
import { ReactComponent as PaytmIcon } from "../../Assets/img/icons/paytm.svg"
import { ReactComponent as MobiKwikIcon } from "../../Assets/img/icons/mobikwik.svg"
import { ReactComponent as BhimUpiIcon } from "../../Assets/img/icons/bhim-upi.svg"
import { ReactComponent as AmazonPayIcon } from "../../Assets/img/icons/amazon-pay.svg"

//Music
import { ReactComponent as SpotifyIcon } from "../../Assets/img/icons/spotify.svg"
import { ReactComponent as AppleMusicIcon } from "../../Assets/img/icons/apple-music.svg"
import { ReactComponent as AmazonMusicIcon } from "../../Assets/img/icons/amazon-music.svg"
import { ReactComponent as JioSaavnIcon } from "../../Assets/img/icons/jio-saavn.svg"
import { ReactComponent as YoutubeMusicIcon } from "../../Assets/img/icons/youtube-music.svg"

//More
import { ReactComponent as LinktreeIcon } from "../../Assets/img/icons/link-tree.svg"

//Default
import { ReactComponent as DefaultIcon } from '../../Assets/img/icons/icon-not-available.svg'

const recommendedLinks = [
    { icon: LinkedinIcon, label: 'LinkedIn', network: 'linkedin' },
    { icon: GmailIcon, label: 'Gmail', network: 'gmail' },
    { icon: FacebookIcon, label: 'Facebook', network: 'facebook' },
    { icon: InstagramIcon, label: 'Instagram', network: 'instagram' },
    // { icon: WhatsappIcon, label: 'WhatsApp', network: 'whatsapp' },
  ];

  const contactLinks = [
    // { icon: ContactCardIcon, label: 'Contact Card', network: 'contactCard' },
    { icon: GmailIcon, label: 'Gmail', network: 'gmail' },
    { icon: GMapIcon, label: 'Address', network: 'googleAddress' },
    { icon: FacetimeIcon, label: 'FaceTime', network: 'facetime' },
    { icon: SignalIcon, label: 'Signal', network: 'signal' },
    { icon: OutlookIcon, label: 'Outlook', network: 'outlook' },
    // { icon: WhatsappIcon, label: 'WhatsApp', network: 'whatsapp' },
  ];
  
  const socialMediaLinks = [
    { icon: LinkedinIcon, label: 'LinkedIn', network: 'linkedin' },
    { icon: FacebookIcon, label: 'Facebook', network: 'facebook' },
    { icon: InstagramIcon, label: 'Instagram', network: 'instagram' },
    { icon: TwitterIcon, label: 'Twitter', network: 'twitter' },
    { icon: TelegramIcon, label: 'Telegram', network: 'telegram' },
    { icon: TwitchIcon, label: 'Twitch', network: 'twitch' },
    { icon: ThreadsIcon, label: 'Threads', network: 'threads' },
    { icon: SnapchatIcon, label: 'Snapchat', network: 'snapchat' },
    { icon: YoutubeIcon, label: 'YouTube', network: 'youtube' },
  ];
  
  const businessLinks = [
    { icon: BookMyShowIcon, label: 'BookMyShow', network: 'bookMyShow' },
    { icon: GoogleReviewIcon, label: 'Google Review', network: 'googleReview' },
    { icon: JustDialIcon, label: 'JustDial', network: 'Justdial' },
  ];
  
  const portfolioLinks = [
    { icon: DribbleIcon, label: 'Dribble', network: 'dribble' },
    { icon: BehanceIcon, label: 'Behance', network: 'behance' },
    { icon: GithubIcon, label: 'GitHub', network: 'github' },
    { icon: AdobePortfolioIcon, label: 'Adobe Portfolio', network: 'adobePortfolio' },
    { icon: FigmaIcon, label: 'Figma', network: 'figma' },
    { icon: PublicIcon, label: 'Website', network: 'website' },
    { icon: MdInsertLink, label: 'Portfolio', network: 'ownportfolio' },
  ];
  
  const contentLinks = [
    { icon: ShareChatIcon, label: 'Share Chat', network: 'shareChat' },
    { icon: TumblrIcon, label: 'Tumblr', network: 'tumblr' },
  ];

  const paymentLinks = [
    { icon: PhonePeIcon, label: 'PhonePe', network: 'phonepe' },
    { icon: GooglePayIcon, label: 'Google Pay', network: 'googlePay' },
    { icon: PayPalIcon, label: 'Pay Pal', network: 'payPal' },
    { icon: PaytmIcon, label: 'Paytm', network: 'paytm' },
    { icon: MobiKwikIcon, label: 'Mobi Kwik', network: 'mobiKwik' },
    { icon: BhimUpiIcon, label: 'BHIM', network: 'bhimUpi' },
    { icon: AmazonPayIcon, label: 'Amazon Pay', network: 'amazonPay' },
  ];
  
  const musicLinks = [
    { icon: SpotifyIcon, label: 'Spotify', network: 'spotify' },
    { icon: AppleMusicIcon, label: 'Apple Music', network: 'appleMusic' },
    { icon: AmazonMusicIcon, label: 'Amazon Music', network: 'amazonMusic' },
    { icon: JioSaavnIcon, label: 'Jio Saavn', network: 'jioSaavn' },
    { icon: YoutubeMusicIcon, label: 'YouTube Music', network: 'youtubeMusic' },
  ];
  
//   const realEstateLinks = [
//     // Add real estate links here
//   ];
  
  const moreLinks = [
    { icon: LinktreeIcon, label: 'Linktree', network: 'linktree' },
  ];
  
  export const socialLinksSections = [
    { title: 'Recommended', links: recommendedLinks },
    { title: 'Contact', links: contactLinks },
    { title: 'Social Media', links: socialMediaLinks },
    { title: 'Business', links: businessLinks },
    { title: 'Portfolio', links: portfolioLinks },
    { title: 'Content', links: contentLinks },
    { title: 'Payment', links: paymentLinks },
    { title: 'Music', links: musicLinks },
    // { title: 'Real Estate', links: realEstateLinks },
    { title: 'More', links: moreLinks },
  ];

  export const getIconAndLabel = (network) => {
    for (const section of socialLinksSections) {
      for (const link of section.links) {
        if (link.network === network) {
          return { icon: link.icon, label: link.label };
        }
      }
    }
    return { icon: DefaultIcon, label: 'Default' }; // fallback for icon and label
  };
